import { Link } from "react-router-dom";
import { Instagram, Phone, Mail } from "lucide-react";
import { CONTACT } from "../lib/assets";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-ink text-cream/90">
    <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-20 grid gap-14 md:grid-cols-12">
      <div className="md:col-span-5">
        <img src="/schonell-logo.png" alt="Schonell Projects" className="h-10 w-auto [filter:brightness(0)_invert(1)]" />
        <p className="mt-6 max-w-sm text-sm font-light leading-relaxed text-cream/60">
          A considered approach to residential renovation and project management — guiding
          homeowners through beautifully executed transformations.
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="text-xs uppercase tracking-[0.24em] text-cream/40 mb-5">Explore</p>
        <ul className="space-y-3 text-sm font-light">
          {[
            { to: "/about", label: "About" },
            { to: "/services", label: "Services" },
            { to: "/projects", label: "Projects" },
            { to: "/contact", label: "Contact" },
          ].map((l) => (
            <li key={l.to}>
              <Link to={l.to} className="text-cream/70 hover:text-cream transition-colors">
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-4">
        <p className="text-xs uppercase tracking-[0.24em] text-cream/40 mb-5">Get in touch</p>
        <ul className="space-y-4 text-sm font-light">
          <li className="flex items-center gap-3">
            <Phone size={15} className="text-cream/50" />
            <a href={`tel:${CONTACT.phoneRaw}`} className="text-cream/70 hover:text-cream transition-colors">
              {CONTACT.phone}
            </a>
          </li>
          <li className="flex items-center gap-3">
            <Mail size={15} className="text-cream/50" />
            <a href={`mailto:${CONTACT.email}`} className="text-cream/70 hover:text-cream transition-colors">
              {CONTACT.email}
            </a>
          </li>
          <li className="flex items-center gap-3">
            <Instagram size={15} className="text-cream/50" />
            <a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" className="text-cream/70 hover:text-cream transition-colors">
              {CONTACT.instagram}
            </a>
          </li>
        </ul>
        <p className="mt-6 text-sm font-light text-cream/50">{CONTACT.location}</p>
      </div>
    </div>

    <div className="border-t border-cream/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-cream/40">© {new Date().getFullYear()} Schonell Projects. All rights reserved.</p>
        <p className="text-xs text-cream/40">Residential Renovation & Project Management</p>
      </div>
    </div>
  </footer>
);
